package com.anjuros.website.redesign.sections.blog

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdGhostButton
import com.anjuros.website.redesign.components.RdLink
import com.anjuros.website.redesign.components.RdPicture
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdSectionHead
import com.anjuros.website.redesign.components.RdTag
import com.anjuros.website.redesign.styles.BlogGuideBodyStyle
import com.anjuros.website.redesign.styles.BlogGuideFigureStyle
import com.anjuros.website.redesign.styles.BlogGuideStyle
import com.anjuros.website.redesign.styles.BlogInsideStyle
import com.anjuros.website.redesign.styles.BlogPathStyle
import com.anjuros.website.redesign.styles.RdSectionFlushTopStyle
import com.anjuros.website.redesign.styles.RdSectionStyle
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.rdList
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

/** Every article, numbered in the order they're best read. */
@Composable
fun BlogGuidesSection() {
    RdSection(
        id = "guides",
        labelledBy = "guides-h",
        modifier = RdSectionStyle.toModifier().then(RdSectionFlushTopStyle.toModifier()),
    ) {
        RdSectionHead(RdText.BLOG_GUIDES_EYEBROW, "guides-h", RdText.BLOG_GUIDES_TITLE, RdText.BLOG_GUIDES_LEDE)
        Ol(BlogPathStyle.toModifier().toAttrs()) {
            BlogGuides.forEach { GuideItem(it) }
        }
    }
}

@Composable
private fun GuideItem(guide: RdBlogGuide) {
    Li(BlogGuideStyle.toModifier().toAttrs()) {
        RdTag("figure", BlogGuideFigureStyle.toModifier()) {
            // The picture opens the article too. It repeats the title link, so screen readers and keyboards skip it.
            RdLink(guide.card.pathToArticle, Modifier.attrsModifier { attr("tabindex", "-1"); attr("aria-hidden", "true") }) {
                RdPicture(guide.image, LocalText(guide.imageAlt))
            }
        }
        Div(BlogGuideBodyStyle.toModifier().toAttrs()) {
            BlogMeta(guide)
            H3 { RdLink(guide.card.pathToArticle) { Text(LocalText(guide.card.title)) } }
            P { Text(LocalText(guide.card.beginningDisplayText)) }
            Div(BlogInsideStyle.toModifier().toAttrs()) {
                P { Text(LocalText(RdText.BLOG_INSIDE)) }
                Ul { rdList(LocalText(guide.inside)).forEach { Li { Text(it) } } }
            }
            RdGhostButton(guide.card.pathToArticle, RdText.BLOG_READ_ARTICLE, withArrow = true)
        }
    }
}
